import { render, staticRenderFns } from "./Addflat.vue?vue&type=template&id=ad3f4c36&scoped=true"
import script from "./Addflat.vue?vue&type=script&lang=js"
export * from "./Addflat.vue?vue&type=script&lang=js"
import style0 from "./Addflat.vue?vue&type=style&index=0&id=ad3f4c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3f4c36",
  null
  
)

export default component.exports